var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.658 3.499a5.27 5.27 0 0 1 3.728-1.544h2.864a.5.5 0 0 1 .5.5v3.818a.5.5 0 0 1-.5.5h-2.864a.454.454 0 0 0-.454.454v2.364h3.318a.5.5 0 0 1 .485.621l-.954 3.818a.5.5 0 0 1-.485.38h-2.364v7.136a.5.5 0 0 1-.5.5H9.614a.5.5 0 0 1-.5-.5v-7.137H6.75a.5.5 0 0 1-.5-.5v-3.818a.5.5 0 0 1 .5-.5h2.364V7.227c0-1.398.555-2.74 1.544-3.728m3.728-.544a4.273 4.273 0 0 0-4.272 4.272v2.864a.5.5 0 0 1-.5.5H7.25v2.818h2.364a.5.5 0 0 1 .5.5v7.137h2.818v-7.137a.5.5 0 0 1 .5-.5h2.473l.705-2.818h-3.178a.5.5 0 0 1-.5-.5V7.227a1.455 1.455 0 0 1 1.454-1.454h2.364V2.955z",
    clipRule: "evenodd"
  })));
};
export default SvgIconFacebook;